import { useCallback } from 'react';
import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { SMSDataV4, SMSDataSharedUtils } from '@frontend/api-sms-data';
import { GetWebsocketEventHandler, useWebsocketEventSubscription } from '@frontend/websocket';

export const useThreadAiStateWSHandler = () => {
  const unifiedThreadUpdater = SMSDataV4._QueryUpdaters.useUnifiedThreadUpdater();
  const getUnifiedThreadEnabled = SMSDataSharedUtils.useGetUnifiedThreadEnabled();
  const fusionEnabled = SMSDataSharedUtils.useGetFusionEnabled();

  const wsEventHandler = useCallback<GetWebsocketEventHandler<NotificationType.THREAD_AI_STATE>>(
    async (event) => {
      const { params } = event;
      const locationId = params.threadAiActivity.locationId ?? '';

      if (getUnifiedThreadEnabled([locationId]) && fusionEnabled) {
        await unifiedThreadUpdater.upsertUnifiedThread({
          matchValues: {
            threadId: params.threadAiActivity.threadId ?? '',
            locationId,
          },
          updater: (thread) => {
            return thread
              ? {
                  ...thread,
                  aiStatus: {
                    status: params.threadAiActivity.status,
                    statusDetails: params.threadAiActivity.details,
                    isActive: params.threadAiActivity.isActive,
                    isEscalated: params.threadAiActivity.isEscalated,
                  },
                }
              : undefined;
          },
          isOptimistic: false,
        });

        await unifiedThreadUpdater.upsertThreadItem({
          matchValues: {
            threadId: params.threadAiActivity.threadId ?? '',
            locationId,
            threadItemId: '',
          },
          updater: () => {
            return {
              aiActivity: {
                ...params.threadAiActivity,
              },
            };
          },
          isOptimistic: false,
        });
      }
    },
    [fusionEnabled, getUnifiedThreadEnabled, unifiedThreadUpdater]
  );

  return wsEventHandler;
};

export const useThreadAiStateWSSubscription = () => {
  const handler = useThreadAiStateWSHandler();
  return useWebsocketEventSubscription(NotificationType.THREAD_AI_STATE, handler);
};
